export const FETCH_UPSELLS_REQUEST = 'FETCH_UPSELLS_REQUEST';
export const FETCH_UPSELLS_SUCCESS = 'FETCH_UPSELLS_SUCCESS';
export const FETCH_UPSELLS_FAILURE = 'FETCH_UPSELLS_FAILURE';

export const ADD_UPSELL_PRODUCT_REQUEST = 'ADD_UPSELL_PRODUCT_REQUEST';
export const ADD_UPSELL_PRODUCT_SUCCESS = 'ADD_UPSELL_PRODUCT_SUCCESS';
export const ADD_UPSELL_PRODUCT_FAILURE = 'ADD_UPSELL_PRODUCT_FAILURE';

export const REMOVE_UPSELL_PRODUCT_REQUEST = 'REMOVE_UPSELL_PRODUCT_REQUEST';
export const REMOVE_UPSELL_PRODUCT_SUCCESS = 'REMOVE_UPSELL_PRODUCT_SUCCESS';
export const REMOVE_UPSELL_PRODUCT_FAILURE = 'REMOVE_UPSELL_PRODUCT_FAILURE';

export const REMOVE_UPSELL_PRODUCTS_BATCH_REQUEST = 'REMOVE_UPSELL_PRODUCTS_BATCH_REQUEST';
export const REMOVE_UPSELL_PRODUCTS_BATCH_SUCCESS = 'REMOVE_UPSELL_PRODUCTS_BATCH_SUCCESS';
export const REMOVE_UPSELL_PRODUCTS_BATCH_FAILURE = 'REMOVE_UPSELL_PRODUCTS_BATCH_FAILURE';
